import type {
    LabsMessageToLive,
    LabsMessageToPlatform,
} from "@/client/core/platform-types/labs.api";
import { isPluginParentOrigin } from "@/client/core/services/plugin-parent-origin";
import { LabsMessageToLiveType } from "@/client/core/platform-types/labs.api";

export type SendPluginMessage = (message: LabsMessageToPlatform, transfer?: Transferable[]) => void;
export type OnPortMessage = (message: LabsMessageToLive) => void;

type PendingMessage = [LabsMessageToPlatform, Transferable[]?];

export const createSendPluginMessage = (
    onMessage: OnPortMessage,
    onError: (title: string, error: unknown) => void,
): SendPluginMessage => {
    const pendingMessages: PendingMessage[] = [];
    let internalSend: SendPluginMessage = (message, transfer) => {
        pendingMessages.push([message, transfer]);
    };

    const handler = (portMessageEvent: MessageEvent): void => {
        if (!isPluginParentOrigin(portMessageEvent.origin)) {
            return;
        }

        const portMessage = portMessageEvent.data as LabsMessageToLive;
        if (portMessage.type !== LabsMessageToLiveType.PortTransfer) {
            return;
        }

        if (portMessageEvent.ports.length === 0) {
            onError("Communication", "No port received in handshake");
            return;
        }

        const port = portMessageEvent.ports[0];
        port.addEventListener("message", (event: MessageEvent): void => {
            onMessage(event.data as LabsMessageToLive);
        });

        internalSend = (messageToSend, transfer) => {
            port.postMessage(messageToSend, transfer ?? []);
        };
        for (const [message, transfer] of pendingMessages) {
            internalSend(message, transfer);
        }
        pendingMessages.length = 0;

        port.start();
        window.removeEventListener("message", handler);
    };
    window.addEventListener("message", handler);

    return (message, transfer) => internalSend(message, transfer);
};
